
















































import { Instance } from '@empathybroker/tsclient-play/dist/models/instance/instance';

import { mapActions, mapGetters } from 'vuex';

import { Button as EpbButton, InstanceCard, UiTextbox } from '../components';

import { ColorEnum, SeasonEnum } from '../enums';

import { ListAnimationMixin } from '../mixins/list-animation.mixin';

import { ROUTER_CONSTS } from '../router/router.consts';

import { AUTH_CONSTS } from '../store/auth/auth.consts';
import { CONFIG_CONSTS } from '../store/config/config.consts';
import { CONTEXT_CONSTS } from '../store/context/context.consts';

import { DateUtils, StringUtils } from '../utils';

export default {
  name: 'instance-selector',
  mixins: [ListAnimationMixin],
  components: {
    UiTextbox,
    InstanceCard,
    EpbButton
  },
  computed: {
    ...mapGetters(AUTH_CONSTS.moduleName, {
      authTokenInfo: AUTH_CONSTS.getters.tokenInfo
    }),
    ...mapGetters(CONFIG_CONSTS.moduleName, {
      instances: CONFIG_CONSTS.getters.instances
    }),
    visibleInstances: function (): Instance[] {
      if (!!this.query) {
        const normalizedQuery = StringUtils.normalize(this.query);
        return this.instances.filter((instance: Instance) => (
          !!instance.prettyName && StringUtils.normalize(instance.prettyName).includes(normalizedQuery) ||
          !!instance.instanceId && StringUtils.normalize(instance.instanceId).includes(normalizedQuery)
        ));
      }
      return !this.showAllInstances ? this.instances.slice(0, this.instancesShownByDefault) : this.instances;
    },
    showAllInstancesMessage: function (): string {
      if (!this.showAllInstances) {
        return this.$epb.utils.compileMessage(this.messages.showAll, { counter: this.instances.length });
      } else {
        return this.messages.showLess;
      }
    },
    seasonImageUrl: function (): string {
      return require(`../assets/media/image/seasons/${ this.season }.png`);
    },
    season: function (): SeasonEnum {
      return DateUtils.getSeason(new Date());
    }
  },
  data: function () {
    return {
      query: '',
      queryInputTimeout: undefined,
      showAllInstances: false,
      instancesShownByDefault: 8,
      messages: this.$epb.messages.app.instanceSelector,
      ColorEnum,
      ROUTER_CONSTS
    };
  },
  methods: {
    ...mapActions(CONTEXT_CONSTS.moduleName, {
      setContext: CONTEXT_CONSTS.actions.setContext
    }),
    onQueryInput: function (query: string): void {
      clearTimeout(this.queryInputTimeout);
      this.queryInputTimeout = setTimeout(() => {
        this.query = query;
      }, 300);
    },
    onInstanceCardClick: function (instanceConfig: Instance): void {
      this.setContext({
        instanceId: instanceConfig.instanceId
      });
      this.$emit('contextChanged');
    }
  },
  watch: {
    query: function (): void {
      this.showAllInstances = false;
    }
  }
};

